import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useState } from "react";
import { useEffect } from "react";
import { GoEye } from "react-icons/go";
import { setAppError } from "../../../../store/userSlice";

export default function Pending_List({ titles }) {
  const token = localStorage.getItem("nodeToken");
  //   const dispatch = useDispatch();
  const [dependentDetails, setDependentDetails] = useState();
  const [searchWords, setSearchWords] = useState([]);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${monthName.toLowerCase()}-${year}`;
  };
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(dependentDetails?.data || []);
  const getData = async () => {
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/pendingList`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setDependentDetails(response.data);
      }
    } catch (error) {
      console.log("error......", error);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/pendingListReport`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Insurance_OPS2_upload_template`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  console.log("currentList.....print", currentList);
  const [fileter, setFilter] = useState("");
  const filteredList = !fileter
  ? dependentDetails?.data
  : dependentDetails?.data.filter((list) => {
      const formattedIqamaExpiryDate = formatDate(list.iqama_expiry_date_g);
      return formattedIqamaExpiryDate === formattedInputDate;
    });
  return (
    <>
      <div className="flex justify-between items-center gap-x-4 mt-4">
        {/* Left side content */}
        <div className="flex gap-x-4">
          <Search
            searchKey={["DEPENDENT_NAME", "DEPENDENT_IQAMA_NUMBER"]}
            setSearchWords={setSearchWords}
          />
          <button
            className="bg-black text-white px-4 rounded-md py-2 text-sm h-[36px]"
            // onClick={() => downloadFile()}
          >
            DOWNLOAD
          </button>
        </div>

        {/* Right side buttons */}
        <div className="flex gap-x-4">
          <button
            className="bg-black text-white px-4 rounded-md py-2 text-sm h-[36px]"
            onClick={() => {
              downloadFile();
            }}
          >
            Download APPLICATION
          </button>
        </div>
      </div>
      <div
        className="overflow-x-auto mt-5"
        style={{ backgroundColor: "white" }}
      >
        <table className="min-w-full divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              {titles.map((columnName, index) => (
                <th
                  key={index}
                  scope="col"
                  className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                >
                  {columnName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-gray-10">
            {filteredList?.map((listItem, index) => (
              <tr key={index}>
                <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.DEPENDENT_NAME}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {/* {listItem?.DATE_OF_BIRTH ? listItem?.DATE_OF_BIRTH : "------"} */}
                  {listItem?.DATE_OF_BIRTH
                    ? new Date(listItem?.DATE_OF_BIRTH)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()
                    : "-----"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.DEPENDENT_IQAMA_NUMBER}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.RELATION}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.CLASS}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.GENDER}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.HEAD_OF_FAMILY}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">{"--------"}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.DELAYED_DAYS}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">{"PENDING"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Pagination />
    </>
  );
}
